export default class ModalTemplateService {
  public static noData: string = 'b/d';
  /**
   * Merge object with the same property
   * @param array
   * @param property
   */
    public static mergeObjectsInUnique = (items: any[], property: string): [] => {
      const newArray = new Map();

      items.forEach((item: any) => {
        const propertyValue = item[property];
        if (newArray.has(propertyValue)) {
          newArray.set(propertyValue, { ...item, ...newArray.get(propertyValue) });
        } else {
          newArray.set(propertyValue, item);
        }
      });

      return [...newArray.values()] as [];
    }

    /**
     * Sum values in array by key name
     * @param items
     * @param rowCountName
     */
    public static sumParkingCategoryPlaces = (items: [], rowCountName: any):number => {
      const sum = items
        .map(item => item[rowCountName])
        .reduce((prev, curr) => prev + curr, 0);
      return sum;
    };
}
